// https://vuex.vuejs.org/en/actions.html
import { API } from 'aws-amplify'
import { ErrorMessageHelper } from '../../../errorMessageHelper'

export default {
  listAllClients (context) {
    context.commit('listClientsState', 'in-progress')
    return API.get('worktools', '/clients', {}).then(response => {
      context.commit('listClientsState', 'ok')
      context.commit('listClientsRecords', response)
    }).catch(error => {
      context.commit('listClientsState', 'error')
      ErrorMessageHelper(context, 'Impossible de lister les clients.')
      return Promise.reject(error)
    })
  },
  addClient (context, params) {
    context.commit('editClientState', 'in-progress')
    return API.post('worktools', '/clients', {
      body: {
        libelle: params.libelle,
        couleur: params.couleur
      }
    }).then(response => {
      context.commit('editClientState', 'ok')
      context.dispatch('listAllClients')
    }).catch(error => {
      context.commit('editClientState', 'error')
      ErrorMessageHelper(context, 'Impossible d\'ajouter un client.')
      return Promise.reject(error)
    })
  },
  editClient (context, params) {
    context.commit('editClientState', 'in-progress')
    return API.put('worktools', '/clients/' + params.clientId, {
      body: {
        libelle: params.libelle,
        couleur: params.couleur
      }
    }).then(response => {
      context.commit('editClientState', 'ok')
      context.dispatch('listAllClients')
    }).catch(error => {
      context.commit('editClientState', 'error')
      ErrorMessageHelper(context, 'Impossible de modifier un client.')
      return Promise.reject(error)
    })
  }
}
